import { hasAccessTo } from "src/utils/RoleBasedSecurity/filters";
import { mockData as mockCompanyData } from "src/Pages/Company/CompanyList";
import { COMPANY_MANAGEMENT_SERVICE, restApiRequest } from "src/utils/Api";
import isUuid from "src/utils/jsHelpers/isUuid";
import { companyCompanyPermissionRead } from "src/utils/RoleBasedSecurity/permissions";

const ITEMS_PER_PAGE = 10;

const normalizeTaxNumber = (value = "") => value.replace(/-/g, "");

const mapCompaniesToResults = (companies) =>
  companies.map(({ fullName, id }) => ({
    label: fullName,
    to: `/company/edit/${id}`,
  }));

const mergeCompaniesById = (companiesLists, limit = ITEMS_PER_PAGE) => {
  const seen = new Set();
  const merged = [];

  companiesLists.flat().forEach((company) => {
    if (company?.id && !seen.has(company.id)) {
      seen.add(company.id);
      merged.push(company);
    }
  });

  return merged.slice(0, limit);
};

const matchesTaxNumber = (item, value) => {
  if (!item.taxNumber) {
    return false;
  }

  const normalizedValue = normalizeTaxNumber(value).toLowerCase();
  const normalizedTaxNumber = normalizeTaxNumber(item.taxNumber).toLowerCase();
  return normalizedTaxNumber.includes(normalizedValue);
};

const fetchCompanies = (params, mockFilterKey, value) =>
  restApiRequest(
    COMPANY_MANAGEMENT_SERVICE,
    "/companies",
    "GET",
    {
      params: {
        ...params,
        itemsPerPage: ITEMS_PER_PAGE,
      },
    },
    mockCompanyData.filter((item) => {
      if (mockFilterKey === "id") {
        return item.id === value;
      }
      if (mockFilterKey === "fullName") {
        return item.fullName?.toLowerCase().includes(value.toLowerCase());
      }
      if (mockFilterKey === "taxNumber") {
        return matchesTaxNumber(item, value);
      }
      return false;
    })
  );

const findCompanies = (value, ctx) => {
  if (!hasAccessTo(ctx.userInfo, companyCompanyPermissionRead)) {
    return [];
  }

  if (isUuid(value)) {
    return fetchCompanies({ id: value }, "id", value).then((res) =>
      mapCompaniesToResults(res || [])
    );
  }

  return Promise.all([
    fetchCompanies({ fullName: value }, "fullName", value),
    fetchCompanies({ taxNumber: value }, "taxNumber", value),
  ]).then(([byFullName, byTaxNumber]) =>
    mapCompaniesToResults(
      mergeCompaniesById([byFullName || [], byTaxNumber || []])
    )
  );
};

export default findCompanies;
